import { Config, formParams, isQuiz, markdownToHtml, requestHeaders } from './helper';

export async function fetchConfig(pathwayID) {
  try {
    const response = await fetch(Config.Routing.pathway(pathwayID));

    if (!response.ok) {
      throw new Error(Config.I18n.Errors.Network.FetchConfig);
    }

    const json = await response.json();

    for (let i = 0; i < json.definition.steps.length; i++) {
      let step = json.definition.steps[i];
      const url = Config.Routing.step(pathwayID, step.id);

      const stepResponse = await fetch(url);
      json.definition.steps[i].content = '';
      json.definition.steps[i].footer = '';

      if (!json.definition.steps[i].score) {
        json.definition.steps[i].score = 0;
      }

      if (!stepResponse.ok) {
        json.definition.steps[i].broken = true;
        console.warn(Config.I18n.Errors.Network.FetchStepContent);
        continue;
      }

      const stepJson = await stepResponse.json();
      const {
        content: stepContent = '',
        footer: footerFooter = '',
        summary: stepSummary = '',
      } = stepJson;

      if (stepContent) {
        json.definition.steps[i].content = markdownToHtml(stepContent);
      }

      if (footerFooter) {
        json.definition.steps[i].footer = markdownToHtml(footerFooter);
      }

      if (stepSummary && isQuiz(json.definition.steps[i]?.format)) {
        json.definition.steps[i].summary = markdownToHtml(stepSummary);
      }
    }

    return json;
  } catch (err) {
    throw new Error(Config.I18n.Errors.Network.FetchConfig);
  }
}

export async function fetchUserState() {
  try {
    const response = await fetch(Config.Routing.user);

    if (response.ok === false) {
      return Config.UserState.loggedOut;
    }

    return Config.UserState.loggedIn;
  } catch (err) {
    throw new Error(Config.I18n.Errors.Network.FetchConfig);
  }
}

export async function fetchPathwayProgress(pathwayID) {
  try {
    const response = await fetch(Config.Routing.progress(pathwayID));

    if (!response.ok) {
      throw new Error(Config.I18n.Errors.Network.FetchProgress);
    }

    const json = await response.json();

    const {reload} = json;
    if (reload) {
      location.reload();
    }

    return json;
  } catch (err) {
    throw new Error(Config.I18n.Errors.Network.FetchProgress);
  }
}

export async function fetchQuizForm(formID) {
  try {
    const response = await fetch(Config.Routing.quiz(formID));

    if (!response.ok) {
      throw new Error(Config.I18n.Errors.Network.FailedToLoadQuiz);
    }

    const quizJson = await response.json();

    const {submission} = quizJson;
    if (submission) {
      // TODO: Handle
    }

    return [quizJson];
  } catch (err) {
    throw new Error(Config.I18n.Errors.Network.FailedToLoadQuiz);
  }
}

export async function updateStepStatus(pathwayID, stepID, status) {
  try {
    const url = Config.Routing.updateStep(pathwayID);
    const dataToSend = {
      id: pathwayID,
      step_id: stepID,
      status,
    }

    const response = await fetch(url, {
      method: 'PATCH',
      headers: requestHeaders(),
      body: JSON.stringify(dataToSend),
    });

    const json = await response.json();

    // TODO: Add validation (modal)
    const {reload} = json;
    if (reload) {
      location.reload();
    }

    return json;
  } catch (err) {
    throw new Error(Config.I18n.Errors.Network.FailedToUpdateStep);
  }
}

export async function updateStepData(pathwayID, stepID, data) {
  try {
    const url = Config.Routing.updateStep(pathwayID);
    const dataToSend = {
      id: pathwayID,
      step_id: stepID,
      form_data: data,
    }

    const response = await fetch(url, {
      method: 'PATCH',
      headers: requestHeaders(),
      body: JSON.stringify(dataToSend),
    });

    const json = await response.json();

    const {reload} = json;
    if (reload) {
      location.reload();
    }

    return json;
  } catch (err) {
    throw new Error(Config.I18n.Errors.Network.FailedToUpdateStep);
  }
}

export async function submitForm(formId, data) {
  try {
    const url = `/forms/${formId}/submissions.json`

    const response = await fetch(url, {
      method: 'POST',
      headers: requestHeaders(),
      body: formParams(data),
    })

    if (!response.ok) {
      throw new Error(Config.I18n.Errors.Network.FormSubmission);
    }

    const json = await response.json();

    const {submission} = json;

    if (!submission?.id) {
      throw new Error(Config.I18n.Errors.Network.FormSubmission);
    }

    return submission.id;
  } catch (err) {
    throw new Error(Config.I18n.Errors.Network.FormSubmission);
  }
}
